import listenForResponseOnVoip from './listenForResponseOnVoip';

export default listenForResponseOnVoip;
